import React, { useEffect, useState } from "react";
import "./products.css";
import { useVendorAuth } from "../../store/vendorAuthStore";

const API_BASE = "https://xiadot.com/vendor_api";

const UNIT_OPTIONS = [
  { value: "piece", label: "Piece / Qty" },
  { value: "gram", label: "Gram (g)" },
  { value: "kilogram", label: "Kilogram (kg)" },
  { value: "litre", label: "Litre (L)" },
  { value: "millilitre", label: "Millilitre (ml)" },
  { value: "dozen", label: "Dozen" },
  { value: "pack", label: "Pack" },
  { value: "metre", label: "Metre (m)" },
  { value: "size", label: "Size" },
  { value: "custom", label: "Custom" },
];

const COLOR_OPTIONS = [
  { value: "Red", label: "Red", hex: "#FF0000" },
  { value: "Blue", label: "Blue", hex: "#0000FF" },
  { value: "Green", label: "Green", hex: "#00FF00" },
  { value: "Yellow", label: "Yellow", hex: "#FFFF00" },
  { value: "Black", label: "Black", hex: "#000000" },
  { value: "White", label: "White", hex: "#FFFFFF" },
  { value: "Pink", label: "Pink", hex: "#FFC0CB" },
  { value: "Purple", label: "Purple", hex: "#800080" },
  { value: "Orange", label: "Orange", hex: "#FFA500" },
  { value: "Brown", label: "Brown", hex: "#964B00" },
  { value: "Gray", label: "Gray", hex: "#808080" },
  { value: "Navy", label: "Navy", hex: "#000080" },
  { value: "Cream", label: "Cream", hex: "#FFFDD0" },
  { value: "Maroon", label: "Maroon", hex: "#800000" },
  { value: "Teal", label: "Teal", hex: "#008080" },
  { value: "Silver", label: "Silver", hex: "#C0C0C0" },
  { value: "Gold", label: "Gold", hex: "#FFD700" },
  { value: "Lime", label: "Lime", hex: "#32CD32" },
  { value: "Coral", label: "Coral", hex: "#FF7F50" },
  { value: "Indigo", label: "Indigo", hex: "#4B0082" },
];

const MAIN_CAT_URLS = [
  `${API_BASE}/admin/main_categories/list.php`,
  `${API_BASE}/main_categories/list.php`,
  `${API_BASE}/vendor/main_categories/list.php`,
];
const SUB_CAT_URLS = [
  `${API_BASE}/admin/sub_categories/list.php`,
  `${API_BASE}/sub_categories/list.php`,
  `${API_BASE}/vendor/sub_categories/list.php`,
];

async function tryFetch(urls, headers) {
  for (var i = 0; i < urls.length; i++) {
    try {
      var res = await fetch(urls[i], { headers: headers });
      if (!res.ok) continue;
      var data = await res.json().catch(function () { return null; });
      if (data) return data;
    } catch (e) { /* try next */ }
  }
  return null;
}

const HIDDEN_CATEGORIES = ["yuro combo offer", "yuro special", "yuro special offer"];

function normalizeMainCats(data) {
  var list = data.categories || data.main_categories || data.data || data.result || [];
  if (!Array.isArray(list)) list = [];
  return list
    .filter(function (c) {
      var name = String(c.name || c.category_name || c.main_category_name || c.title || "").toLowerCase().trim();
      return !HIDDEN_CATEGORIES.some(function (h) { return name.includes(h); });
    })
    .map(function (c) {
      return {
        id: String(c.id != null ? c.id : c.category_id != null ? c.category_id : ""),
        label: String(c.name || c.category_name || c.main_category_name || c.title || ""),
        commission:
          c.commission != null ? Number(c.commission)
            : c.commission_percent != null ? Number(c.commission_percent)
              : c.commission_percentage != null ? Number(c.commission_percentage)
                : null,
      };
    });
}

function normalizeSubCats(data) {
  var raw = data.subcategories || data.sub_categories || data.data || data.result || [];
  if (!Array.isArray(raw)) raw = [];
  return raw.map(function (x) {
    return {
      id: String(x.id != null ? x.id : x.sub_id != null ? x.sub_id : ""),
      category_id: String(x.category_id != null ? x.category_id : x.main_category_id != null ? x.main_category_id : ""),
      label: String(x.name || x.subcategory || x.sub_category_name || x.subcategory_name || x.title || ""),
    };
  });
}

// ─────────────────────────────────────────────────────────────
//  Commission Alert Banner
// ─────────────────────────────────────────────────────────────
function CommissionAlert({ commission, categoryLabel }) {
  if (commission == null) return null;
  return (
    <div style={{
      display: "flex", alignItems: "flex-start", gap: 12,
      background: "linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%)",
      border: "1px solid #f59e0b", borderLeft: "4px solid #d97706",
      borderRadius: 10, padding: "14px 16px", margin: "12px 0 4px",
    }}>
      <div style={{
        flexShrink: 0, width: 36, height: 36, borderRadius: 8,
        background: "#d97706", display: "flex", alignItems: "center", justifyContent: "center",
      }}>
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" />
        </svg>
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 4 }}>
          <span style={{ fontWeight: 700, fontSize: 13.5, color: "#92400e" }}>Admin Commission Applicable</span>
          <span style={{ background: "#d97706", color: "white", fontSize: 12, fontWeight: 700, borderRadius: 20, padding: "2px 10px" }}>
            {commission}% Commission
          </span>
        </div>
        <p style={{ margin: 0, fontSize: 12.5, color: "#92400e", lineHeight: 1.55 }}>
          Products listed under <strong>{categoryLabel}</strong> are subject to a{" "}
          <strong>{commission}% platform commission</strong> on every sale. Automatically deducted before payout.
        </p>
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────
//  ✅ LIVE PRICE BREAKDOWN CALCULATOR
//
//  Formula:
//    base        = offer_price  (if set)  else  mrp
//    finalPrice  = base + delivery   ← customer pays (no commission applied)
//    vendorEarns = base              ← vendor gets (no commission deducted)
// ─────────────────────────────────────────────────────────────
// ─────────────────────────────────────────────────────────────────────────────
//  ✅ LIVE PRICE BREAKDOWN CALCULATOR
//
//  Formula (matches backend update.php & get-product-details.php):
//    base          = offer_price  (if set > 0)  else  mrp
//    commissionAmt = vendorEarning × (commission% / 100)
//    finalPrice    = vendorEarning + commissionAmt + delivery   ← customer pays
//    vendorEarns   = vendorEarning (offer price is what vendor earns)
// ─────────────────────────────────────────────────────────────────────────────
export function PriceCalculator({ mrp, offerPrice, deliveryCharge, commission }) {
  var mrpNum = Number(mrp) || 0;
  var offerNum = Number(offerPrice) || 0;
  var deliveryNum = Number(deliveryCharge) || 0;
  var commNum = Number(commission) || 0;

  if (mrpNum <= 0) return null;

  // New logic: Offer price is what customer pays, commission is deducted from offer price
  var customerPays = offerNum > 0 ? offerNum : mrpNum;
  var commissionAmt = commNum > 0 ? parseFloat(((customerPays * commNum) / 100).toFixed(2)) : 0;
  var vendorEarning = parseFloat((customerPays - commissionAmt).toFixed(2));
  // Customer pays = offer price (delivery charge added separately at checkout)
  var finalPrice = parseFloat((vendorEarning + commissionAmt + deliveryNum).toFixed(2));

  var discount = 0;
  var savings = 0;
  if (mrpNum > offerNum && mrpNum > 0) {
    // discount is calculated but not used in display
    savings = mrpNum - offerNum;
  }

  return (
    <div style={{
      background: "linear-gradient(135deg, #f8faff 0%, #eef2ff 100%)",
      border: "1px solid #c7d2fe", borderLeft: "4px solid #4f46e5",
      borderRadius: 12, padding: "16px", margin: "16px 0 4px",
    }}>
      {/* Header */}
      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 14 }}>
        <div style={{
          width: 30, height: 30, borderRadius: 8, background: "#4f46e5",
          display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
        }}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round">
            <line x1="12" y1="1" x2="12" y2="23" />
            <path d="M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6" />
          </svg>
        </div>
        <span style={{ fontWeight: 700, fontSize: 13.5, color: "#312e81" }}>Price Breakdown</span>
        <span style={{
          fontSize: 10.5, color: "#6366f1", background: "#eef2ff",
          border: "1px solid #c7d2fe", borderRadius: 20, padding: "2px 9px",
          marginLeft: "auto", fontWeight: 600,
        }}>
          ⚡ Live Preview
        </span>
      </div>

      {/* Breakdown table */}
      <div style={{ background: "#fff", borderRadius: 8, border: "1px solid #e0e7ff", overflow: "hidden", marginBottom: 12 }}>

        {/* MRP */}
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "9px 12px", borderBottom: "1px solid #f1f5f9", fontSize: 12.5 }}>
          <span style={{ color: "#64748b" }}>MRP</span>
          <span style={{ color: savings > 0 ? "#94a3b8" : "#0f172a", textDecoration: savings > 0 ? "line-through" : "none", fontWeight: 500 }}>
            ₹{mrpNum.toFixed(2)}
          </span>
        </div>

        {/* Offer Price */}
        {offerNum > 0 && (
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "9px 12px", borderBottom: "1px solid #f1f5f9", fontSize: 12.5, background: "#f0fdf4" }}>
            <span style={{ color: "#15803d", fontWeight: 600 }}>Offer Price</span>
            <span style={{ color: "#15803d", fontWeight: 700 }}>₹{offerNum.toFixed(2)}</span>
          </div>
        )}

        {/* Savings */}
        {savings > 0 && (
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "9px 12px", borderBottom: "1px solid #f1f5f9", fontSize: 12.5, background: "#fef2f2" }}>
            <span style={{ color: "#dc2626" }}>Customer Saves (MRP − Offer)</span>
            <span style={{ color: "#dc2626", fontWeight: 600 }}>− ₹{savings.toFixed(2)}</span>
          </div>
        )}

        {/* Vendor Earning */}
        {commissionAmt > 0 && (
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "9px 12px", fontSize: 12.5, background: "#dcfce7" }}>
            <span style={{ color: "#15803d" }}>
              Vendor Earning (₹{customerPays.toFixed(2)} - ₹{commissionAmt.toFixed(2)} commission)
            </span>
            <span style={{ color: "#15803d", fontWeight: 600 }}>₹{vendorEarning.toFixed(2)}</span>
          </div>
        )}
      </div>

      {/* Summary cards */}
      <div style={{ display: "flex", gap: 8 }}>
        {/* Customer pays */}
        <div style={{
          flex: 1,
          background: "linear-gradient(135deg, #4f46e5 0%, #6366f1 100%)",
          borderRadius: 10, padding: "12px 14px", textAlign: "center", color: "#fff",
        }}>
          <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: 0.8, textTransform: "uppercase", opacity: 0.85, marginBottom: 4 }}>
            Customer Pays
          </div>
          <div style={{ fontSize: 22, fontWeight: 900, letterSpacing: -0.5 }}>
            ₹{finalPrice.toFixed(2)}
          </div>
          <div style={{ fontSize: 10, opacity: 0.75, marginTop: 3 }}>
            ₹{vendorEarning.toFixed(2)}
            {commissionAmt > 0 ? ` + ₹${commissionAmt.toFixed(2)} comm` : ""}
            {deliveryNum > 0 ? ` + ₹${deliveryNum.toFixed(2)} del` : ""}
          </div>
        </div>

        {/* Vendor earns */}
        {commissionAmt > 0 && (
          <div style={{
            flex: 1,
            background: "linear-gradient(135deg, #059669 0%, #10b981 100%)",
            borderRadius: 10, padding: "12px 14px", textAlign: "center", color: "#fff",
          }}>
            <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: 0.8, textTransform: "uppercase", opacity: 0.85, marginBottom: 4 }}>
              You Earn
            </div>
            <div style={{ fontSize: 22, fontWeight: 900, letterSpacing: -0.5 }}>
              ₹{vendorEarning.toFixed(2)}
            </div>
            <div style={{ fontSize: 10, opacity: 0.75, marginTop: 3 }}>
              after {commNum}% commission deducted
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

// Variant-specific price breakdown component
export function VariantPriceBreakdown({ variant, deliveryCharge, commission }) {
  var mrpNum = Number(variant.mrp_price) || 0;
  var offerNum = Number(variant.offer_price) || 0;
  var deliveryNum = Number(deliveryCharge) || 0;
  var commNum = Number(commission) || 0;

  if (mrpNum <= 0) return null;

  // New logic: Offer price is what customer pays, commission is deducted from offer price
  var customerPays = offerNum > 0 ? offerNum : mrpNum;
  var commissionAmt = commNum > 0 ? parseFloat(((customerPays * commNum) / 100).toFixed(2)) : 0;
  var vendorEarning = parseFloat((customerPays - commissionAmt).toFixed(2));
  // Customer pays = offer price (delivery charge added separately at checkout)
  var finalPrice = parseFloat((vendorEarning + commissionAmt + deliveryNum).toFixed(2));

  var discount = 0;
  var savings = 0;
  if (mrpNum > offerNum && mrpNum > 0) {
    // discount is calculated but not used in display
    savings = mrpNum - offerNum;
  }

  return (
    <div style={{
      background: "linear-gradient(135deg, #f0fdf4 0%, #f0f9ff 100%)",
      border: "1px solid #bbf7d0", borderLeft: "4px solid #22c55e",
      borderRadius: 10, padding: "14px", margin: "12px 0 4px",
    }}>
      {/* Header */}
      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 12 }}>
        <div style={{
          width: 24, height: 24, borderRadius: 6, background: "#22c55e",
          display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
        }}>
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round">
            <line x1="12" y1="1" x2="12" y2="23" />
            <path d="M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6" />
          </svg>
        </div>
        <span style={{ fontWeight: 700, fontSize: 12, color: "#166534" }}>Variant Price Breakdown</span>
        <span style={{
          fontSize: 9, color: "#059669", background: "#dcfce7",
          border: "1px solid #bbf7d0", borderRadius: 16, padding: "2px 8px",
          marginLeft: "auto", fontWeight: 600,
        }}>
          ⚡ Live Preview
        </span>
      </div>

      {/* Breakdown table */}
      <div style={{ background: "#fff", borderRadius: 6, border: "1px solid #dcfce7", overflow: "hidden", marginBottom: 8 }}>

        {/* MRP */}
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "7px 10px", borderBottom: "1px solid #f1f5f9", fontSize: 11.5 }}>
          <span style={{ color: "#64748b" }}>MRP</span>
          <span style={{ color: savings > 0 ? "#94a3b8" : "#0f172a", textDecoration: savings > 0 ? "line-through" : "none", fontWeight: 500 }}>
            ₹{mrpNum.toFixed(2)}
          </span>
        </div>

        {/* Offer Price */}
        {offerNum > 0 && (
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "7px 10px", borderBottom: "1px solid #f1f5f9", fontSize: 11.5, background: "#f0fdf4" }}>
            <span style={{ color: "#15803d", fontWeight: 600 }}>Offer Price</span>
            <span style={{ color: "#15803d", fontWeight: 700 }}>₹{offerNum.toFixed(2)}</span>
          </div>
        )}

        {/* Savings */}
        {savings > 0 && (
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "7px 10px", borderBottom: "1px solid #f1f5f9", fontSize: 11.5, background: "#fef2f2" }}>
            <span style={{ color: "#dc2626" }}>Customer Saves (MRP − Offer)</span>
            <span style={{ color: "#dc2626", fontWeight: 600 }}>− ₹{savings.toFixed(2)}</span>
          </div>
        )}

        {/* Vendor Earning */}
        {commissionAmt > 0 && (
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "7px 10px", fontSize: 11.5, background: "#dcfce7" }}>
            <span style={{ color: "#15803d" }}>
              Vendor Earning (₹{customerPays.toFixed(2)} - ₹{commissionAmt.toFixed(2)} commission)
            </span>
            <span style={{ color: "#15803d", fontWeight: 600 }}>₹{vendorEarning.toFixed(2)}</span>
          </div>
        )}
      </div>

      {/* Summary cards */}
      <div style={{ display: "flex", gap: 6 }}>
        {/* Customer pays */}
        <div style={{
          flex: 1,
          background: "linear-gradient(135deg, #22c55e 0%, #10b981 100%)",
          borderRadius: 8, padding: "10px 12px", textAlign: "center", color: "#fff",
        }}>
          <div style={{ fontSize: 9, fontWeight: 700, letterSpacing: 0.5, textTransform: "uppercase", opacity: 0.85, marginBottom: 3 }}>
            Customer Pays
          </div>
          <div style={{ fontSize: 18, fontWeight: 900, letterSpacing: -0.5 }}>
            ₹{finalPrice.toFixed(2)}
          </div>
          <div style={{ fontSize: 9, opacity: 0.75, marginTop: 2 }}>
            {offerNum > 0 ? "including commission & delivery" : "including commission"}
          </div>
        </div>

        {/* Vendor earns */}
        {commissionAmt > 0 && (
          <div style={{
            flex: 1,
            background: "linear-gradient(135deg, #059669 0%, #10b981 100%)",
            borderRadius: 8, padding: "10px 12px", textAlign: "center", color: "#fff",
          }}>
            <div style={{ fontSize: 9, fontWeight: 700, letterSpacing: 0.5, textTransform: "uppercase", opacity: 0.85, marginBottom: 3 }}>
              You Earn
            </div>
            <div style={{ fontSize: 18, fontWeight: 900, letterSpacing: -0.5 }}>
              ₹{vendorEarning.toFixed(2)}
            </div>
            <div style={{ fontSize: 9, opacity: 0.75, marginTop: 2 }}>
              after {commNum}% commission deducted
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────
//  AddProduct / EditProduct Modal
// ─────────────────────────────────────────────────────────────
export default function AddProduct({ onClose, onSave, onUpdate, mode, initialData }) {
  mode = mode || "add";
  initialData = initialData || null;
  console.log("Initial product Data ",initialData);

  var auth = useVendorAuth();
  var vendor = auth.vendor;
  var token = auth.token;
  var myVendorId = (vendor && (vendor.id || vendor._id)) ? (vendor.id || vendor._id) : 1;
  var authHeaders = token ? { Authorization: "Bearer " + token } : {};

  var [form, setForm] = useState({
    id: initialData ? (initialData.id || null) : null,
    main_category_id: initialData ? (initialData.main_category_id || "") : "",
    sub_category_id: initialData ? (initialData.sub_category_id || initialData.category_id || "") : "",
    product_name: initialData ? (initialData.name || initialData.product_name || "") : "",
    description: initialData ? (initialData.description || "") : "",
    mrp: initialData ? (initialData.price != null ? String(initialData.price) : initialData.mrp != null ? String(initialData.mrp) : "") : "",
    offer_price: initialData ? (initialData.offer_price != null ? String(initialData.offer_price) : "") : "",
    delivery_charge: initialData ? (initialData.delivery_charge != null ? String(initialData.delivery_charge) : "") : "",
    unit: initialData ? (initialData.unit || "piece") : "piece",
    unit_qty: initialData ? (initialData.unit_qty != null ? String(initialData.unit_qty) : "1") : "1",
    stock: initialData ? (initialData.stock != null ? String(initialData.stock) : "") : "",
    customized_values: initialData && initialData.customized_values ? initialData.customized_values : [""],
    product_variants: initialData && initialData.product_variants ? initialData.product_variants.map(v => ({ ...v })) : [],
    color: initialData ? (initialData.color || "") : "",
    custom_color: "",
    limit_one_per_user: initialData ? (initialData.is_restrict == 1 || initialData.limit_one_per_user == 1 ? true : false) : false,
  });

  var [mainCats, setMainCats] = useState([]);
  var [subCats, setSubCats] = useState([]);
  var [catsLoading, setCatsLoading] = useState(true);
  var [catError, setCatError] = useState("");
  var [images, setImages] = useState(function () {
    if (initialData && initialData.images && initialData.images.length) {
      return initialData.images.map(function (url) {
        var isVid = typeof url === 'string' && url.match(/\.(mp4|webm|ogg)$/i) != null;
        return { file: null, preview: url, existing: url, isVideo: isVid };
      }).concat([{ file: null, preview: null, existing: null, isVideo: false }]);
    }
    return [{ file: null, preview: null, existing: null, isVideo: false }];
  });
  var [loading, setLoading] = useState(false);
  var [formErr, setFormErr] = useState("");

  function set(k, v) { setForm(function (p) { return Object.assign({}, p, { [k]: v }); }); }

  var selectedMainCat = mainCats.find(function (c) { return String(c.id) === String(form.main_category_id); }) || null;
  var selectedCommission = selectedMainCat ? selectedMainCat.commission : null;
  var selectedCatLabel = selectedMainCat ? selectedMainCat.label : "";

  useEffect(function () {
    (async function () {
      setCatsLoading(true); setCatError("");
      var data = await tryFetch(MAIN_CAT_URLS, authHeaders);
      if (!data) { setCatError("Could not load categories."); setCatsLoading(false); return; }
      var cats = normalizeMainCats(data);
      setMainCats(cats);
      if (!form.main_category_id && cats.length > 0) set("main_category_id", cats[0].id);
      setCatsLoading(false);
    })();
  }, [token]); // eslint-disable-line

  useEffect(function () {
    var mid = String(form.main_category_id || "");
    if (!mid) { setSubCats([]); return; }
    (async function () {
      var data = await tryFetch(SUB_CAT_URLS, authHeaders);
      if (!data) { setSubCats([]); return; }
      var filtered = normalizeSubCats(data).filter(function (x) { return x.category_id === mid; });
      setSubCats(filtered);
      var current = String(form.sub_category_id || "");
      if (!filtered.some(function (x) { return x.id === current; })) {
        set("sub_category_id", filtered[0] ? filtered[0].id : "");
      }
    })();
  }, [form.main_category_id, token]); // eslint-disable-line

  function addMediaSlot() { setImages(function (p) { return p.concat([{ file: null, preview: null, existing: null, isVideo: false }]); }); }

  function changeImage(idx, file) {
    if (!file) return;
    var isVid = file.type && file.type.startsWith("video/");
    var reader = new FileReader();
    reader.onload = function (e) {
      setImages(function (p) {
        var c = p.slice(); c[idx] = { file: file, preview: e.target.result, existing: null, isVideo: isVid }; return c;
      });
    };
    reader.readAsDataURL(file);
  }

  function removeImageSlot(idx) {
    setImages(function (p) {
      var next = p.map(function (img, i) {
        if (i === idx) {
          // Mark existing images for deletion
          if (img.existing) {
            return { file: null, preview: null, existing: null, deleted: img.existing };
          }
          return { file: null, preview: null, existing: null };
        }
        return img;
      });
      return next;
    });
  }

  var submit = async function (e) {
    e.preventDefault(); setFormErr("");
    if (!form.main_category_id) { setFormErr("Please select a main category"); return; }
    if (!form.sub_category_id) { setFormErr("Please select a sub category"); return; }
    if (!form.product_name.trim()) { setFormErr("Product name is required"); return; }


    var hasImage = images.some(function (img) {
      return (img.file || img.existing) && !img.deleted;
    });

    if (!hasImage) {
      setFormErr("Please upload at least one product image or video");
      return;
    }





    var offerNum = Number(form.offer_price) || 0;

    var hasValidCustomizedValues = form.customized_values.some(function (val) {
      return val && val.trim() !== "";
    });

    // Only validate main offer price for non-variant products
    if (!hasValidCustomizedValues) {
      if (!offerNum || offerNum <= 0) {
        setFormErr("Offer price is required");
        return;
      }
    }



    // if (!offerNum || offerNum <= 0) {
    //   setFormErr("Offer price is required");
    //   return;
    // }
    if (Number(form.offer_price) > 0 && Number(form.offer_price) > Number(form.mrp)) {
      setFormErr("Offer price must be less than MRP");
      return;
    }

    // Check if using variants or main pricing
    // var hasValidCustomizedValues = form.customized_values.some(function (val) { return val && val.trim() !== ""; });

    // Declare validProductVariants BEFORE the if block so it's always in scope
    // var validProductVariants = form.product_variants.filter(variant =>
    //   variant.value && variant.value.trim() !== "" && variant.mrp_price && parseFloat(variant.mrp_price) > 0
    // );

    var validProductVariants = form.product_variants.filter(variant =>
      variant.value &&
      variant.value.trim() !== "" &&
      variant.mrp_price &&
      parseFloat(variant.mrp_price) > 0 &&
      variant.offer_price &&
      parseFloat(variant.offer_price) > 0
    );

    if (hasValidCustomizedValues) {
      if (validProductVariants.length === 0) {
        setFormErr("Please enter MRP price for at least one variant");
        return;
      }
    } else {
      // Validate main pricing
      var priceNum = Number(form.mrp || 0);
      if (!priceNum || priceNum <= 0) { setFormErr("Enter a valid MRP / price"); return; }
    }

    // Calculate final price using same logic as PriceCalculator


    var deliveryNum = Number(form.delivery_charge) || 0;
    // vendorEarning is calculated but not used in display
    // Customer pays = offer price + commission (delivery charge added separately at checkout)
    // finalPrice is calculated but not used in display

    var fd = new FormData();
    fd.append("vendor_id", String(myVendorId));
    fd.append("main_category_id", String(form.main_category_id));
    fd.append("sub_category_id", String(form.sub_category_id));
    fd.append("product_name", form.product_name.trim());
    fd.append("name", form.product_name.trim());
    fd.append("description", (form.description || "").trim());
    // Handle pricing based on whether variants are used
    if (hasValidCustomizedValues) {
      // For variant products, use the first variant's MRP as the main price (for compatibility)
      var firstVariant = form.product_variants.find(variant =>
        variant.value && variant.value.trim() !== "" && variant.mrp_price && parseFloat(variant.mrp_price) > 0
      );
      var mainPrice = firstVariant ? parseFloat(firstVariant.mrp_price) : 0;
      fd.append("price", String(mainPrice));
      fd.append("offer_price", ""); // Main offer price not used for variant products
      fd.append("stock", "0"); // Main stock not used for variant products
    } else {
      // For simple products, use main pricing
      fd.append("price", String(priceNum));
      fd.append("offer_price", String(offerNum > 0 ? offerNum : ""));
      fd.append("stock", String(Number(form.stock || 0)));
    }

    fd.append("delivery_charge", String(deliveryNum));
    fd.append("unit", form.unit || "piece");
    fd.append("unit_qty", String(Number(form.unit_qty || 1)));
    fd.append("is_active", "1");

    // Add customized values
    var validCustomizedValues = form.customized_values.filter(val => val.trim() !== "");
    if (validCustomizedValues.length > 0) {
      fd.append("customized_values", JSON.stringify(validCustomizedValues));
    }

    // Add comprehensive variants

    // Add comprehensive variants
    if (validProductVariants.length > 0) {
      fd.append("product_variants", JSON.stringify(validProductVariants));
    }
    // Add color (prioritize custom color, otherwise use predefined)
    var finalColor = form.custom_color.trim() || form.color.trim();
    if (finalColor) {
      fd.append("color", finalColor);
    }
    var finalColor = form.custom_color.trim() || form.color.trim();
    if (finalColor) {
      fd.append("color", finalColor);
    }


    fd.append("limit_one_per_user", form.limit_one_per_user ? "1" : "0"); // ← add here

    var newFiles = images.filter(function (img) { return img.file != null; });
    newFiles.forEach(function (img) { fd.append("images[]", img.file); });

    // Handle deleted images
    var deletedImages = images.filter(function (img) { return img.deleted != null; });
    console.log("Deleted images found:", deletedImages);
    if (deletedImages.length > 0) {
      var deletedUrls = deletedImages.map(function (img) { return img.deleted; });
      console.log("Sending deleted_images:", deletedUrls);
      fd.append("deleted_images", JSON.stringify(deletedUrls));
    }

    try {
      setLoading(true);
      if (mode === "add") {
        var res = await fetch(API_BASE + "/vendor/products/add.php", { method: "POST", headers: authHeaders, body: fd });
        var text = await res.text(); var data = {}; try { data = JSON.parse(text); } catch (err) { }
        if (!res.ok || data.success !== true) { 
            setFormErr(data.message || "Server did not return success. Response: " + text.slice(0, 50)); 
            return; 
        }
        if (onSave) onSave({ id: Number(data.id || 0), name: fd.get("name"), description: fd.get("description"), price: Number(fd.get("price")), offer_price: Number(fd.get("offer_price")), delivery_charge: Number(fd.get("delivery_charge")), unit: fd.get("unit"), unit_qty: Number(fd.get("unit_qty")), stock: Number(fd.get("stock")), customized_values: validCustomizedValues, product_variants: validProductVariants, color: finalColor, images: data.images || (data.image_url ? [data.image_url] : []) ,limit_one_per_user: form.limit_one_per_user ? 1 : 0 });
        if (onClose) onClose(); return;
      }
      if (mode === "edit") {
        fd.append("id", String(form.id));
        var res2 = await fetch(API_BASE + "/vendor/products/update.php", { method: "POST", headers: authHeaders, body: fd });
        var text2 = await res2.text(); var data2 = {}; try { data2 = JSON.parse(text2); } catch (err) { }
        if (!res2.ok || data2.success !== true) { 
            setFormErr(data2.message || "Server did not return success. Response: " + text2.slice(0, 50)); 
            return; 
        }
        console.log("Update response data:", data2);
        if (onUpdate) onUpdate({ id: Number(form.id), name: form.product_name.trim(), description: form.description || "", price: priceNum, offer_price: offerNum, delivery_charge: deliveryNum, unit: form.unit, unit_qty: Number(form.unit_qty || 1), stock: Number(form.stock || 0), customized_values: validCustomizedValues, product_variants: validProductVariants, color: finalColor, images: data2.images || [], newFiles: newFiles.map(function (img) { return img.file; }) ,limit_one_per_user: form.limit_one_per_user ? 1 : 0 });
        if (onClose) onClose();
      }
    } catch (err) { setFormErr(err.message || "Server error"); }
    finally { setLoading(false); }
  };

  return (
    <div className="vp-overlay" onMouseDown={onClose}>
      <div className="vp-modal" onMouseDown={function (e) { e.stopPropagation(); }}>

        {/* Header */}
        <div className="vp-modal-head">
          <div className="vp-modal-head-left">
            <div className={"vp-modal-icon" + (mode === "edit" ? " vp-modal-icon-edit" : "")}>
              {mode === "edit" ? (
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
                  <path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" />
                  <path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" />
                </svg>
              ) : (
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
                  <line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" />
                </svg>
              )}
            </div>
            <div>
              <h3 className="vp-modal-title">{mode === "edit" ? "Edit Product" : "Add Product"}</h3>
              <p className="vp-modal-sub">{mode === "edit" ? ("Editing \"" + form.product_name + "\"") : "Fill in the details below"}</p>
            </div>

            {catError && (
              <div className="vp-form-err" style={{ background: "#fff7ed", borderColor: "#fed7aa", color: "#9a3412" }}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" style={{ flexShrink: 0 }}>
                  <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
                  <line x1="12" y1="9" x2="12" y2="13" /><line x1="12" y1="17" x2="12.01" y2="17" />
                </svg>
                {catError}
              </div>
            )}
            {formErr && (
              <div className="vp-form-err">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" style={{ flexShrink: 0 }}>
                  <circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" />
                </svg>
                {formErr}
              </div>
            )}
          </div>
          <button className="vp-close-btn" onClick={onClose}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
              <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>

        {/* Body */}
        <form className="vp-modal-body" onSubmit={submit}>


          {/* Categories */}
          <div className="vp-section-title">Category</div>
          <div className="vp-grid2">
            <div className="vp-form-group">
              <label className="vp-label">Main Category</label>
              <select className="vp-input vp-select" value={String(form.main_category_id || "")} disabled={catsLoading}
                onChange={function (e) { set("main_category_id", e.target.value); set("sub_category_id", ""); }}>
                <option value="">{catsLoading ? "Loading…" : mainCats.length === 0 ? "No categories found" : "Select main category…"}</option>
                {mainCats.map(function (c) {
                  return <option key={c.id} value={c.id}>{c.label}{c.commission != null ? " (" + c.commission + "% commission)" : ""}</option>;
                })}
              </select>
            </div>
            <div className="vp-form-group">
              <label className="vp-label">Sub Category</label>
              <select className="vp-input vp-select" value={String(form.sub_category_id || "")}
                disabled={!form.main_category_id || catsLoading}
                onChange={function (e) { set("sub_category_id", e.target.value); }}>
                <option value="">{!form.main_category_id ? "Select main category first" : subCats.length === 0 ? "No sub-categories" : "Select sub category…"}</option>
                {subCats.map(function (c) { return <option key={c.id} value={c.id}>{c.label}</option>; })}
              </select>
            </div>
          </div>

          <CommissionAlert commission={selectedCommission} categoryLabel={selectedCatLabel} />

          {/* Product Info */}
          <div className="vp-section-title">Product Info</div>
          <div className="vp-form-group">
            <label className="vp-label">Product Name</label>
            <input className="vp-input" placeholder="Enter product name" value={form.product_name}
              onChange={function (e) { set("product_name", e.target.value); }} />
          </div>
          <div className="vp-form-group">
            <label className="vp-label">Description <span className="vp-label-opt">(optional)</span></label>
            <textarea className="vp-input vp-textarea" placeholder="Describe your product…" value={form.description}
              onChange={function (e) { set("description", e.target.value); }} />
          </div>

          {/* Measurement */}
          <div className="vp-section-title">Measurement Unit</div>
          <div className="vp-grid2">
            <div className="vp-form-group">
              <label className="vp-label">Unit Type</label>
              <select className="vp-input vp-select" value={form.unit} onChange={function (e) { set("unit", e.target.value); }}>
                {UNIT_OPTIONS.map(function (u) { return <option key={u.value} value={u.value}>{u.label}</option>; })}
              </select>
            </div>
            <div className="vp-form-group">
              <label className="vp-label">Qty per stock item <span className="vp-label-opt">(e.g. 500 for 500g)</span></label>
              <input className="vp-input" placeholder="1" value={form.unit_qty}
                onChange={function (e) { set("unit_qty", e.target.value); }} />
            </div>
          </div>

          {/* Customized Values */}
          <div className="vp-form-group" style={{ marginTop: 14 }}>
            <label className="vp-label">Customized Values <span className="vp-label-opt">(optional - e.g. 7 inch, 2kg pack)</span></label>
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              {form.customized_values.map(function (value, index) {
                return (
                  <div key={index} style={{ display: "flex", gap: 8, alignItems: "center" }}>
                    <input
                      className="vp-input"
                      placeholder="Enter customized value (e.g. 7 inch)"
                      value={value}
                      onChange={function (e) {
                        var newValues = [...form.customized_values];
                        newValues[index] = e.target.value;
                        set("customized_values", newValues);

                        // Auto-add comprehensive variant if this is a new value
                        if (e.target.value && e.target.value.trim() !== "") {
                          var existingVariant = form.product_variants.find(function (v) { return v.value === e.target.value; });
                          if (!existingVariant) {
                            set("product_variants", [...form.product_variants, { value: e.target.value, mrp_price: "", offer_price: "", stock_quantity: "" }]);
                          }
                        }
                      }}
                      style={{ flex: 1 }}
                    />
                    {form.customized_values.length > 1 && (
                      <button
                        type="button"
                        className="vp-btn-remove"
                        onClick={function () {
                          var newValues = form.customized_values.filter(function (_, i) { return i !== index; });
                          set("customized_values", newValues);

                          // Remove corresponding comprehensive variant
                          if (value) {
                            var newVariants = form.product_variants.filter(function (v) { return v.value !== value; });
                            set("product_variants", newVariants);
                          }
                        }}
                        style={{
                          width: 32, height: 32, borderRadius: 6, border: "1px solid #e2e8f0",
                          background: "#fff", color: "#ef4444", cursor: "pointer",
                          display: "flex", alignItems: "center", justifyContent: "center"
                        }}
                        title="Remove this value"
                      >
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
                        </svg>
                      </button>
                    )}
                  </div>
                );
              })}
              <button
                type="button"
                className="vp-btn-add"
                onClick={function () {
                  set("customized_values", [...form.customized_values, ""]);
                }}
                style={{
                  width: "100%", padding: "8px 12px", borderRadius: 6,
                  border: "1px dashed #3b82f6", background: "#eff6ff",
                  color: "#3b82f6", cursor: "pointer", fontSize: 13,
                  display: "flex", alignItems: "center", justifyContent: "center", gap: 6
                }}
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" />
                </svg>
                Add Customized Value
              </button>
            </div>
          </div>

          {/* Comprehensive Variants - Pricing & Stock */}
          {form.customized_values.some(function (val) { return val && val.trim() !== ""; }) && (
            <div className="vp-form-group">
              <label className="vp-label">Pricing & Stock per Variant <span className="vp-label-opt">(set MRP, offer price & stock for each variant)</span></label>
              <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
                {form.customized_values.filter(function (val) { return val && val.trim() !== ""; }).map(function (value, index) {
                  var variant = form.product_variants.find(function (v) { return v.value === value; }) || { value: value, mrp_price: "", offer_price: "", stock_quantity: "" };
                  var variantIndex = form.product_variants.findIndex(function (v) { return v.value === value; });

                  return (
                    <div key={value} style={{
                      border: "1px solid #e5e7eb", borderRadius: 8, padding: 16,
                      background: "#f9fafb"
                    }}>
                      <div style={{ fontWeight: 600, marginBottom: 12, color: "#374151", fontSize: 14, borderBottom: "1px solid #e5e7eb", paddingBottom: 8 }}>
                        Variant: {value}
                      </div>
                      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 12 }}>
                        <div>
                          <label style={{ fontSize: 12, color: "#6b7280", marginBottom: 4, display: "block", fontWeight: 500 }}>
                            MRP Price (₹) *
                          </label>
                          <input
                            className="vp-input"
                            placeholder="0.00"
                            type="number"
                            step="0.01"
                            min="0"
                            value={variant.mrp_price}
                            onChange={function (e) {
                              var newVariants = [...form.product_variants];
                              if (variantIndex >= 0) {
                                newVariants[variantIndex].mrp_price = e.target.value;
                              } else {
                                newVariants.push({ value: value, mrp_price: e.target.value, offer_price: "", stock_quantity: "" });
                              }
                              set("product_variants", newVariants);
                            }}
                          />
                        </div>
                        <div>
                          <label style={{ fontSize: 12, color: "#6b7280", marginBottom: 4, display: "block", fontWeight: 500 }}>
                            Offer Price (₹)
                          </label>
                          <input
                            className="vp-input"
                            placeholder="0.00"
                            type="number"
                            step="0.01"
                            min="0"
                            value={variant.offer_price}
                            onChange={function (e) {
                              var newVariants = [...form.product_variants];
                              if (variantIndex >= 0) {
                                newVariants[variantIndex].offer_price = e.target.value;
                              } else {
                                newVariants.push({ value: value, mrp_price: "", offer_price: e.target.value, stock_quantity: "" });
                              }
                              set("product_variants", newVariants);
                            }}
                          />
                        </div>
                        <div>
                          <label style={{ fontSize: 12, color: "#6b7280", marginBottom: 4, display: "block", fontWeight: 500 }}>
                            Stock Quantity *
                          </label>
                          <input
                            className="vp-input"
                            placeholder="0"
                            type="number"
                            min="0"
                            value={variant.stock_quantity}
                            onChange={function (e) {
                              var newVariants = [...form.product_variants];
                              if (variantIndex >= 0) {
                                newVariants[variantIndex].stock_quantity = e.target.value;
                              } else {
                                newVariants.push({ value: value, mrp_price: "", offer_price: "", stock_quantity: e.target.value });
                              }
                              set("product_variants", newVariants);
                            }}
                          />
                        </div>
                      </div>
                      <div style={{ marginTop: 8, fontSize: 11, color: "#9ca3af" }}>
                        * MRP Price and Stock Quantity are required for each variant
                      </div>

                      {/* Variant Price Breakdown */}
                      {(variant.mrp_price || variant.offer_price) && (
                        <VariantPriceBreakdown
                          variant={variant}
                          deliveryCharge={form.delivery_charge}
                          commission={selectedCommission}
                        />
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          )}

          {/* Color Selection */}
          <div className="vp-form-group" style={{ marginTop: 14 }}>
            <label className="vp-label">Color <span className="vp-label-opt">(optional - choose predefined or enter custom)</span></label>
            <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
              {/* Predefined Colors */}
              <div>
                <label style={{ fontSize: 12, color: "#6b7280", marginBottom: 6, display: "block" }}>Choose from predefined colors:</label>
                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(120px, 1fr))", gap: 8 }}>
                  {COLOR_OPTIONS.map(function (color) {
                    return (
                      <button
                        key={color.value}
                        type="button"
                        onClick={function () {
                          set("color", color.value);
                          set("custom_color", "");
                        }}
                        style={{
                          padding: "8px 12px",
                          border: form.color === color.value ? "2px solid #3b82f6" : "1px solid #d1d5db",
                          borderRadius: 6,
                          background: "#fff",
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          gap: 8,
                          fontSize: 13,
                          transition: "all 0.2s"
                        }}
                      >
                        <div
                          style={{
                            width: 16,
                            height: 16,
                            borderRadius: 3,
                            backgroundColor: color.hex,
                            border: color.hex === "#FFFFFF" || color.hex === "#FFFDD0" ? "1px solid #d1d5db" : "none"
                          }}
                        />
                        {color.label}
                      </button>
                    );
                  })}
                </div>
              </div>

              {/* Custom Color Input */}
              <div>
                <label style={{ fontSize: 12, color: "#6b7280", marginBottom: 6, display: "block" }}>
                  Or enter custom color name:
                </label>
                <div style={{ display: "flex", gap: 8 }}>
                  <input
                    className="vp-input"
                    placeholder="e.g., Peach, Lavender, Turquoise"
                    value={form.custom_color}
                    onChange={function (e) {
                      set("custom_color", e.target.value);
                      set("color", ""); // Clear predefined selection
                    }}
                    style={{ flex: 1 }}
                  />
                  {form.custom_color && (
                    <button
                      type="button"
                      onClick={function () {
                        set("custom_color", "");
                      }}
                      style={{
                        width: 32, height: 32, borderRadius: 6, border: "1px solid #e2e8f0",
                        background: "#fff", color: "#ef4444", cursor: "pointer",
                        display: "flex", alignItems: "center", justifyContent: "center"
                      }}
                      title="Clear custom color"
                    >
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
                      </svg>
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Pricing & Stock - Show only when no customized values are used */}
          {!form.customized_values.some(function (val) { return val && val.trim() !== ""; }) && (
            <>
              <div className="vp-section-title">Pricing & Stock</div>
              <div className="vp-grid2">
                <div className="vp-form-group">
                  <label className="vp-label">MRP (₹)</label>
                  <input className="vp-input" placeholder="0.00" value={form.mrp}
                    onChange={function (e) { set("mrp", e.target.value); }} />
                </div>
                <div className="vp-form-group">
                  <label className="vp-label">Offer Price (₹) </label>
                  <input className="vp-input" placeholder="0.00" value={form.offer_price}
                    onChange={function (e) { set("offer_price", e.target.value); }} />
                </div>
                <div className="vp-form-group">
                  <label className="vp-label">Delivery Charge (₹) <span className="vp-label-opt">(common for all variants)</span></label>
                  <input className="vp-input" placeholder="0.00" value={form.delivery_charge}
                    onChange={function (e) { set("delivery_charge", e.target.value); }} />
                </div>
                <div className="vp-form-group">
                  <label className="vp-label">Stock</label>
                  <input className="vp-input" placeholder="0" value={form.stock}
                    onChange={function (e) { set("stock", e.target.value); }} />
                </div>
              </div>

              {/* ✅ LIVE PRICE CALCULATOR */}
              <PriceCalculator
                mrp={form.mrp}
                offerPrice={form.offer_price}
                deliveryCharge={form.delivery_charge}
                commission={selectedCommission}
              />
            </>
          )}

          {/* Delivery Charge - Always visible when variants are used */}
          {form.customized_values.some(function (val) { return val && val.trim() !== ""; }) && (
            <div className="vp-form-group" style={{ marginTop: 20 }}>
              <label className="vp-label">Delivery Charge (₹) <span className="vp-label-opt">(common for all variants)</span></label>
              <input className="vp-input" placeholder="0.00" value={form.delivery_charge}
                onChange={function (e) { set("delivery_charge", e.target.value); }} />
            </div>
          )}
          {/* Limit One Per User */}
          <div className="vp-form-group" style={{ marginTop: 14 }}>
            <label style={{
              display: "flex", alignItems: "flex-start", gap: 12,
              background: form.limit_one_per_user
                ? "linear-gradient(135deg, #fef3c7 0%, #fffbeb 100%)"
                : "#f9fafb",
              border: form.limit_one_per_user ? "1px solid #f59e0b" : "1px solid #e5e7eb",
              borderLeft: form.limit_one_per_user ? "4px solid #d97706" : "4px solid #e5e7eb",
              borderRadius: 10, padding: "14px 16px", cursor: "pointer",
              transition: "all 0.2s"
            }}>
              <input
                type="checkbox"
                checked={form.limit_one_per_user}
                onChange={function (e) { set("limit_one_per_user", e.target.checked); }}
                style={{ width: 18, height: 18, marginTop: 1, accentColor: "#d97706", cursor: "pointer", flexShrink: 0 }}
              />
              <div style={{ flex: 1 }}>
                <div style={{
                  fontWeight: 700, fontSize: 13.5,
                  color: form.limit_one_per_user ? "#92400e" : "#374151",
                  marginBottom: 3
                }}>
                  Limit to 1 per customer
                  {form.limit_one_per_user && (
                    <span style={{
                      marginLeft: 8, background: "#d97706", color: "white",
                      fontSize: 11, fontWeight: 700, borderRadius: 20, padding: "2px 9px"
                    }}>
                      Active
                    </span>
                  )}
                </div>
                <p style={{ margin: 0, fontSize: 12.5, color: form.limit_one_per_user ? "#92400e" : "#6b7280", lineHeight: 1.55 }}>
                  Each customer can purchase this product <strong>only once</strong>. Useful for exclusive offers, trial packs, or one-time deals.
                </p>
              </div>
            </label>
          </div>

          {/* Media */}
          <div className="vp-section-title" style={{ marginTop: 20 }}>
            Product Images & Video
            <span className="vp-label-opt" style={{ marginLeft: 8, textTransform: "none", letterSpacing: 0 }}>
              ({images.filter(function (i) { return (i.file || i.existing) && !i.deleted; }).length} added)
            </span>
          </div>
          <div className="vp-img-preview-grid">
            {images.map(function (img, idx) {
              var hasContent = img.file || img.existing;
              var isDeleted = img.deleted != null;
              return (
                <div key={idx} className={"vp-img-slot" + (hasContent && !isDeleted ? " vp-img-slot-filled" : "")}>
                  {hasContent && !isDeleted ? (
                    <>
                      {img.isVideo ? (
                        <video src={img.preview || img.existing} className="vp-img-slot-preview" autoPlay muted loop playsInline style={{ objectFit: 'cover', width: '100%', height: '100%' }} />
                      ) : (
                        <img src={img.preview || img.existing} alt={"media-" + idx} className="vp-img-slot-preview" />
                      )}
                      {idx === 0 && <span className="vp-img-main-badge">Main</span>}
                      <button type="button" className="vp-img-slot-remove" onClick={function () { removeImageSlot(idx); }}>
                        <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round">
                          <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
                        </svg>
                      </button>
                    </>
                  ) : (
                    <label className="vp-img-slot-empty">
                      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
                        <rect x="3" y="3" width="18" height="18" rx="2" /><circle cx="8.5" cy="8.5" r="1.5" /><polyline points="21 15 16 10 5 21" />
                      </svg>
                      <span>{idx === 0 ? "Main media" : "Add media"}</span>
                      <input type="file" accept="image/*,video/*" style={{ display: "none" }}
                        onChange={function (e) { changeImage(idx, e.target.files ? e.target.files[0] : null); }} />
                    </label>
                  )}
                </div>
              );
            })}
            {images.length < 6 && (
              <button type="button" className="vp-img-slot vp-img-slot-add" onClick={addMediaSlot}>
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                  <line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" />
                </svg>
                <span>More</span>
              </button>
            )}
          </div>
          <p style={{ fontSize: 11.5, color: "var(--text-3)", marginTop: 4 }}>
            First image is the main product photo. You can add up to 6 images.
          </p>

          {/* Footer */}
          <div className="vp-modal-footer">
            <button type="button" className="vp-btn-cancel" onClick={onClose}>Cancel</button>
            <button type="submit" className={"vp-btn-save" + (mode === "edit" ? " vp-btn-update" : "")} disabled={loading}>
              {loading ? (
                <span><span className="vp-btn-spinner" />{mode === "edit" ? "Updating…" : "Saving…"}</span>
              ) : (
                <span>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
                    <polyline points="20 6 9 17 4 12" />
                  </svg>
                  {mode === "edit" ? "Update Product" : "Save Product"}
                </span>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
